module.exports = "img/ellipsis.c2118e5.svg";